var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1190_54708",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.227051 8.29272L7.08599 1.43379C7.86704 0.652739 9.13337 0.65274 9.91441 1.43379L16.7734 8.29272L8.5002 16.5659L0.227051 8.29272Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.227051 8.29272L7.08599 1.43379C7.86704 0.652739 9.13337 0.65274 9.91441 1.43379L16.7734 8.29272L8.5002 16.5659L0.227051 8.29272Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.480056 7.58562L6.37888 0.726682C7.55045 -0.444892 9.44995 -0.444891 10.6215 0.726682L9.20731 2.1409C8.81678 1.75037 8.18362 1.75037 7.79309 2.1409L0.934158 8.99983L-0.480056 7.58562ZM16.7734 8.29272L8.5002 16.5659L16.7734 8.29272ZM8.5002 16.5659L0.227051 8.29272L8.5002 16.5659ZM6.37888 0.726682C7.55045 -0.444892 9.44995 -0.444891 10.6215 0.726682L17.4805 7.58562L16.0662 8.99983L9.20731 2.1409C8.81678 1.75037 8.18362 1.75037 7.79309 2.1409L6.37888 0.726682Z",
    fill: "#E4E6EA",
    mask: "url(#path-1-inside-1_1190_54708)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.a8a259e161f80a0b4b8183f88cff722b.svg";
export { ForwardRef as ReactComponent };